import { Button, Grid, Typography } from '@mui/material';
import { useCallback } from 'react';

import { useCanvasStore } from '@/modules/canvas/store';
import { logger } from '@common/logging/logger';

import { DEBUG_ACTION_SIZE, DEBUG_DESCRIPTION_SIZE } from './DebugModal';

export const LogCurrentCanvasElementsButton = () => {
  const canvas = useCanvasStore((state) => state.instance);

  const handleClick = useCallback(() => {
    if (!canvas) {
      logger.warn('Canvas instance not initialized.');
      return;
    }
    
    logger.info('[Debug] Current canvas elements', canvas.getElementsByTag(/.*/));
  }, [canvas]);

  return (
    <>
      <Grid item xs={DEBUG_DESCRIPTION_SIZE}>
        <Typography>Log current canvas elements</Typography>
      </Grid>
      <Grid item xs={DEBUG_ACTION_SIZE}>
        <Button onClick={handleClick}>Click</Button>
      </Grid>
    </>
  );
};
